import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import {notify} from "reapop";
import i18n from "../../i18n";

export function removeFile(
    FileID,
    {FarmID, ClientID, LocalUserID} = {},
    addHistory = true
) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    return invokeApig({
        ...Paths.removeFile({
            farmID: _FarmID,
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        queryParams: {
            FileID,
            addHistory,
        },
    });
}

export function removeFiles(FileIDs, {FarmID, ClientID, LocalUserID} = {}) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    return invokeApig({
        ...Paths.removeFile({
            farmID: _FarmID,
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        queryParams: {
            FileID: FileIDs,
        },
    });
}

export function removeFileNotificationSuccess(
    response,
    {uniqueId = myID()} = {}
) {
    store.dispatch(
        notify({
            id: uniqueId,
            title: i18n.t("apiNotifications.removeFileTitle"),
            message: i18n.t("apiNotifications.removeFileSuccess"),
            status: "success",
            dismissible: true,
            dismissAfter: 5000,
        })
    );
}

export function removeFileNotificationFailure(
    response,
    {uniqueId = myID()} = {}
) {
    store.dispatch(
        notify({
            id: uniqueId,
            title: i18n.t("apiNotifications.removeFileTitle"),
            message: i18n.t("apiNotifications.removeFileFailure"),
            status: "error",
            dismissible: true,
            // buttons: checkLogsButton(),
            dismissAfter: 15000,
        })
    );
}
